import {match} from 'ts-pattern';

import {always, isEmpty} from 'ramda';

/**
 * Normalizes filter values: false -> undefined, empty -> null, else passthrough.
 * Ported from features/datagrid (eag-grid must not import from that lib).
 */
export const processFilterValues = (
  filterValues: Record<string, unknown>
): Record<string, unknown> =>
  Object.entries(filterValues).reduce(
    (acc, [key, value]) => {
      acc[key] = match(value)
        .with(false, always(undefined))
        .when(isEmpty, always(null))
        .otherwise(always(value));

      return acc;
    },
    {} as Record<string, unknown>
  );
